import { z } from 'zod/v4';

export const CreateAdminDocumentTypeBodySchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().max(255).optional(),
  impactAreaId: z.string().max(255).optional(),
  documentClass: z
    .enum(['TRANSACTIONAL', 'COMPANY', 'PRODUCT'])
    .optional()
    .default('COMPANY'),
});

export type CreateAdminDocumentTypeBodyType = z.infer<
  typeof CreateAdminDocumentTypeBodySchema
>;
